import React from 'react';
import useStyles from './useStyles';
import { SurveyLogo } from '~lib/generatedGqlTypes';

export type Props = Omit<SurveyLogo, 'enabled'> &
  Partial<{ altText: string }> &
  Partial<{ children: never }> &
  React.HTMLAttributes<HTMLDivElement>;

export function Logo({
  id,
  size,
  height,
  width,
  image,
  verticalAlignment,
  altText,
  ...props
}: Props): React.ReactElement {
  const { logoContainer, logoWrapper, logoImage } = useStyles({ verticalAlignment, size, width, height });
  const url = image?.url ?? '';

  return (
    <div id={id} className={logoContainer} {...props}>
      <div className={logoWrapper}>
        <img src={url} alt={altText} className={logoImage} />
      </div>
    </div>
  );
}

export default Logo;
